<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Editar recurso humano</h2>
    <FormPerson :basePerson="person" @submit-requested="submitRequested"></FormPerson>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormPerson from '../forms/FormPerson.vue'
import router from '@/router';

  export default {
  components: { FormPerson },
    computed:{
      ...mapState('people', ['personOutput']),
      person: function()
      {
        return this.personOutput && this.personOutput.obj ? this.personOutput.obj.employee : null;
      }
    },
    methods: {
      ...mapActions('people', ['editPerson']),
      ...mapActions('people', ['updateCredentials']),
      ...mapActions('people', ['getPerson']),
      ...mapActions('messages', ['addMessage']),
      ...mapActions('messages', ['removeMessages']),
      submitRequested (inputPerson, inputCredentials, inputMessage, alertsRemoveIds) {
        // Update user info
        this.editPerson(inputPerson);

        // Change credentials
        if(inputCredentials)
        {
          this.updateCredentials(inputCredentials);
        }

        // Send message
        if(inputMessage)
        {
          this.addMessage(inputMessage);
        }

        // Delete alerts (TODO Multiple)
        if(alertsRemoveIds && alertsRemoveIds.length)
        {
          this.removeMessages(alertsRemoveIds);
        }
      },
    },
    mounted: function()
    {
      if(!this.$route.params.id)
      {
        router.push({ path: '/pessoas/lista' });
      }
      else
      {
        this.getPerson(this.$route.params.id);
      }
    }
  }
</script> 
 
<style scoped>
</style> 